var render = function render(){var _vm=this,_c=_vm._self._c;return _c('demands',{attrs:{"dashboard-sections":_vm.dashboardSections,"loading":_vm.loading,"demands":_vm.allDemands(_vm.demands),"filtered-demands":_vm.filteredDemands},on:{"setDemands":function($event){return _vm.setDemands($event)},"updateDemands":function($event){return _vm.listDemands()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }